/**
 * Uit gesprekken (controle blok 1, punt 5): de feiten uit telefoon-
 * gesprekken bij de klant (belnotitie van de receptie, notitie van JP,
 * samenvatting), niet het gesprek zelf. Nieuwste eerst, hooguit vijf.
 *
 * Sessie 73 blok 3: met `klantId` staat per feit een tekstknop
 * "Op de kaart" die de copiloot vraagt het dier bij te werken (event
 * `copiloot:vraag`; de copiloot luistert zelf). `onCopiloot` opent op de
 * iPhone het copilootvlak.
 */
import type { KaartGespreksfeit } from "../types";
import { datumKort } from "../opmaak";
import { vraagCopiloot } from "./opDeKaart";

const BRON: Record<string, string> = {
  JP: "JP",
  receptie: "receptie",
  samenvatting: "samenvatting",
};

export function UitGesprekken({
  feiten,
  klantId,
  onCopiloot,
}: {
  feiten: KaartGespreksfeit[];
  klantId?: string;
  onCopiloot?: () => void;
}) {
  return (
    <ul className="kk-gespreksfeiten" data-testid="uit-gesprekken">
      {feiten.map((f) => (
        <li key={`${f.moment}-${f.tekst.slice(0, 20)}`}>
          <span className="tekst">{f.tekst}</span>
          <small>
            {`${BRON[f.bron] ?? f.bron}, ${datumKort(f.moment)}`}
            {klantId ? (
              <button
                type="button"
                className="kk-tekstknop"
                onClick={() => {
                  vraagCopiloot(klantId, f);
                  onCopiloot?.();
                }}
              >
                Op de kaart
              </button>
            ) : null}
          </small>
        </li>
      ))}
    </ul>
  );
}
